export function getFullName(user) {
    if (!user) {
        return '';
    }
    return user.givenName + ' ' + user.familyName;
}
